import { useNavigate } from "react-router-dom";
import { Stack, Typography, useTheme, Button } from "@mui/material";
import { Icon } from "@iconify/react";
import { useResponsive } from "@app/hooks";
import { Strings } from "@app/constants";
import { PATH_DASHBOARD } from "@app/routes/paths";

const DetailItem = ({ label, value, valueColor }: any) => (
  <Stack direction="row" justifyContent="space-between" sx={{ mb: 1.5 }}>
    <Typography variant="body2" color="#989898" fontWeight="medium">
      {label}:
    </Typography>
    <Typography
      variant="body2"
      sx={{ color: valueColor || "#5F5F5F" }}
      fontWeight="bold"
    >
      {value || "N/A"}
    </Typography>
  </Stack>
);

const SellingCarDetails = ({ sellData, myOrdersData, setSelectedTab }: any) => {
  const navigate = useNavigate();
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();

  return (
    <>
      {sellData && sellData?.length > 0 && (
        <Stack
          direction="row"
          alignItems="center"
          onClick={() => setSelectedTab("all")}
          sx={{
            color: theme.palette.common.black,
            cursor: "pointer",
            "&:hover": { opacity: 0.8 },
            mb: 2,
          }}
        >
          <Icon
            icon="mdi:arrow-left"
            width={18}
            color={theme.palette.common.black}
          />
          <Typography sx={{ fontWeight: 700, fontSize: 18, ml: 1 }}>
            Sell Car Details
          </Typography>
        </Stack>
      )}

      <Stack
        sx={{
          height: "65vh",
          overflowY: "auto",
          pr: 1,
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {sellData && sellData.length > 0 ? (
          sellData.map((item: any) => {
            const carData = item?.sellCar || item?.car || {};
            return (
              <Stack
                key={item?.id}
                direction={isMobile ? "column" : "row"}
                sx={{
                  backgroundColor: "#F7F7F7",
                  borderRadius: 3,
                  p: 3,
                  mb: 3,
                  gap: 3,
                }}
              >
                <Stack
                  sx={{
                    width: isMobile ? "100%" : "60%",
                    position: "relative",
                    borderRadius: 2,
                    overflow: "hidden",
                    flex: 1,
                  }}
                >
                  <img
                    loading="lazy"
                    src={
                      carData?.images?.[0]?.url ||
                      carData?.brand?.image ||
                      ""
                    }
                    alt={`${carData?.brand?.name || ""} ${
                      carData?.model?.name || ""
                    }`}
                    style={{
                      width: "100%",
                      height: 295,
                      objectFit: "cover",
                    }}
                  />

                  <Stack
                    sx={{
                      position: "absolute",
                      top: 16,
                      right: 16,
                      backgroundColor: "#FFDFB3",
                      color: "#985902",
                      fontWeight: "bold",
                      py: 0.5,
                      px: 2,
                      borderRadius: "6px",
                      fontSize: "0.8rem",
                    }}
                  >
                    Sell
                  </Stack>
                </Stack>
                <Stack sx={{ width: isMobile ? "100%" : "40%" }}>
                  <Stack spacing={2}>
                    <DetailItem
                      label="Car Name"
                      value={`${carData?.brand?.name ?? ""} ${
                        carData?.model?.name ?? ""
                      }`.trim()}
                      valueColor={theme.palette.primary.main}
                    />

                    <DetailItem
                      label="Brand"
                      value={carData?.brand?.name}
                    />

                    <DetailItem
                      label="Model"
                      value={carData?.model?.name}
                    />

                    <DetailItem
                      label="Year"
                      value={carData?.manufacturingYear}
                    />

                    <DetailItem
                      label="Fuel Type"
                      value={carData?.model?.fuelType}
                    />

                    <DetailItem
                      label="Transmission"
                      value={carData?.transmission}
                    />

                    <DetailItem
                      label="Variant"
                      value={
                        Array.isArray(carData?.variant)
                          ? carData.variant.join(", ")
                          : carData?.variant
                      }
                    />

                    <DetailItem
                      label="Kilometers"
                      value={carData?.driven}
                    />
                    <DetailItem
                      label="Price"
                      value={
                        carData?.price !== undefined &&
                        !isNaN(Number(carData.price))
                          ? Number(carData.price).toLocaleString("en-IN", {
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            })
                          : "N/A"
                      }
                    />
                  </Stack>
                </Stack>
              </Stack>
            );
          })
        ) : (
          <Stack
            sx={{
              width: "100%",
              height: 200,
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: 24 }}>
              {Strings.wishlist.noProductsFoundInMyOrders}
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate(PATH_DASHBOARD.productListPage)}
            >
              {Strings.button.bookMyOrders}
            </Button>
          </Stack>
        )}
      </Stack>
    </>
  );
};

export { SellingCarDetails };